<template>
  <b-modal
    modal-class="help-modal"
    size="lg"
    :visible="visible"
    :no-fade="true"
    :hide-header="true"
    :body-bg-variant="'flat-clouds'"
    @hide="hide()"
    @shown="onShown()"
  >
    <form
      class="h5 modal-header w-100 mb-0 pt-0 px-0"
      @submit.prevent="ask()"
    >
      <div class="media w-100 align-items-center">
        <div class="media-body">
          <trix
            class="trix-mini input w-100"
            placeholder="Type your question here"
            v-model="question"
          ></trix>
        </div>
        <div class="media-right ml-2">
          <button
            type="submit"
            class="btn btn-primary mb-0"
            :disabled="loading"
            @click.prevent="ask()"
          >
            <span class="h5 mb-0">
              <span class="mr-1 d-none d-md-inline-block">Submit</span>
              <i v-if="!loading" class="fa fa-fw fa-arrow-right" />
              <i v-if="loading" class="fa fa-fw fa-circle-o-notch fa-spin" />
            </span>
          </button>
        </div>
      </div>
    </form>
    <div
      v-if="!showMessage"
    >
      <div v-if="showTip" class="mt-5 mb-5 pb-5 text-center animated shake">
        <div class="h3 mb-4">
          <i class="fa fa-hand-o-up mr-1" />
        </div>
        {{ salutation }}. To request help,
        <br>type your question above.
      </div>
      <div
        v-if="showSendMessageNow"
        class="text-center my-3">
        <p
          v-if="results === false && !loading"
        >
          I couldn't find any answers to this question.
        </p>
        <p
          v-if="loading"
          class="h3 mb-4"
        >
          <i class="fa fa-circle-o-notch fa-spin" />
        </p>
        <p
          v-if="results && !loading"
        >
          I found some solutions for you.
        </p>
        <button
          class="btn btn-dark"
          @click.prevent="showMessage = true">
          Send Message Instead
          <i class="fa fa-arrow-right ml-2"></i>
        </button>
      </div>
      <div v-if="results" v-html="results" class="results bg-flat-clouds pt-3 px-3 pb-0"></div>
      <div
        v-if="showSendMessageNow && results !== false"
        class="text-center my-5">
        <button
          class="btn btn-dark"
          @click.prevent="showMessage = true">
          Send Message Instead
          <i class="fa fa-arrow-right ml-2"></i>
        </button>
      </div>
    </div>

    <div
      class="mt-3"
      v-if="showMessage"
    >
      <div
        v-if="to.id"
        class="form-group"
      >
        <label class="small position-absolute text-uppercase text-muted">To</label>
        <div class="form-control input-lg d-flex">
          <span class="agent-profile-img x-small mr-2 align-self-center" :style="`background-image: url(${to.image});`"></span>
          <span class="align-self-center">
            {{ to.name }}
          </span>
        </div>
      </div>
      <div class="form-group">
        <label for="help[from.name]" class="small position-absolute text-uppercase text-muted">
          Name
        </label>
        <input
          id="help[from.name]"
          type="text"
          v-model="from.name"
          class="form-control input-lg"
          placeholder=""
        />
      </div>
      <div class="form-group">
        <label for="help[from.email]" class="small position-absolute text-uppercase text-muted">
          Email
        </label>
        <input
          id="help[from.email]"
          type="email"
          v-model="from.email"
          class="form-control input-lg"
          placeholder=""
        />
      </div>
      <div class="form-group">
        <label for="help[from.phone]" class="small position-absolute text-uppercase text-muted">
          Phone
        </label>
        <masked-input
          id="help[from.phone]"
          type="text"
          v-model="from.phone"
          :mask="['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
          class="form-control input-lg"
          placeholder=""
        ></masked-input>
      </div>
      <div class="form-group">
        <trix
          v-model="message"
          placeholder="Provide more information here"
        ></trix>
      </div>
      <div class="form-group">
        <div class="files">
          <div
            v-for="file in files"
            v-bind:key="file.id"
            class="file card mb-1"
          >
            <div class="card-body p-0 pl-2">
              <div class="media">
                <div class="small media-body align-self-center">
                  <b>{{ file.name }}</b> ({{ bytes(file.size) }})
                </div>
                <div class="media-right align-self-center">
                  <button
                    class="btn btn-sm btn-link text-body"
                    @click.prevent="removeAttachment(file.id)"
                  >
                    <i class="fa fa-close" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <upload v-on:uploaded="onFileUploaded">
          <span slot="button">
            <button class="btn btn-sm btn-white">
              <i class="fa fa-fw fa-paperclip mr-1" />
              <span>
                Attach File...
              </span>
            </button>
          </span>
        </upload>
      </div>
    </div>

    <div slot="modal-footer" class="w-100 d-flex bg-white">
      <button
        v-if="!showMessage"
        class="mr-auto btn btn-white"
        @click.prevent="hide()"
      >
        Close
      </button>
      <button
        v-if="showMessage"
        class="mr-auto btn btn-white"
        @click.prevent="showMessage = false"
      >
        <i class="fa fa-arrow-left mr-1" />
        Back
      </button>
      <button
        v-if="showMessage"
        class="btn btn-primary"
        :disabled="disableSendButton || sending"
        @click.prevent="send()"
      >
        <i
          v-if="!sending"
          class="fa fa-fw fa-paper-plane mr-1"
        />
        <i
          v-if="sending"
          class="fa fa-fw fa-circle-o-notch fa-spin mr-1"
        />
        <span
          v-if="!sending"
        >
          Send Message
        </span>
        <span
          v-if="sending"
        >
          Sending...
        </span>
      </button>
    </div>

  </b-modal>
</template>

<style lang="scss">
.help-modal {
  .modal-content {
    border: 0;
  }

  .modal-body {
    height: 70vh;
    overflow: scroll;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }

  .form-group {
    position: relative;
    label {
      left: 10px;
      top: 50%;
      margin-top: -10px;
      height: 20px;
    }
    .form-control {
      padding-left: 70px;
    }
  }

  @media screen and (max-width: 768px) {
    .modal-content {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 0;
    }

    .modal-body {
      border-radius: 0;
      position: fixed;
      top: 0;
      height: calc(100vh - 71px);
      left: 0;
      right: 0;
      bottom: 71px;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
    }

    .modal-footer {
      position: fixed;
      bottom: 0;
      width: 100%;
    }
  }
}
</style>

<script>
import $ from 'jquery'
import Trix from "./Trix";
import { debounce, get, filter } from 'lodash'
import { searchSupport, sendSupportTicket } from '@/api'
import MaskedInput from 'vue-text-mask'
import Upload from '@/components/Upload'
import numeral from 'numeral'
import { MessageBag } from '@/lib/MessageBag'
import alertify from 'alertify.js'

const $window = $(window)

export default {
  components: {
    MaskedInput,
    Trix,
    Upload
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      error: false,
      question: null,
      visible: false,
      showMessage: false,
      showSendMessageNow: false,
      sending: false,
      message: null,
      showTip: true,
      results: null,
      loading: false,
      to: {
        //
      },
      from: {
        name: this.user.name,
        email: this.user.email,
        phone: this.user.phone
      },
      files: []
    }
  },
  mounted () {
    $(document).keydown((e) => {
      if (this.isHelpKey(e)) {
        this.toggle()
        e.preventDefault()
      }
    })

    $window.on('help.requested', (e, options) => {
      this.to = get(options, 'to')
      this.show()
    })
  },
  watch: {
    question () {
      this.showTip = false
      // THIS WAS REPLACED BY ask(): this.search($('<span></span>').html(this.question).text())
    }
  },
  computed: {
    salutation () {
      return `Hi ${this.user.first_name || 'there'}`
    },
    disableSendButton () {
      return !this.from.name || !this.from.email || !this.question
    }
  },
  methods: {
    ask () {
      this.search($('<span></span>').html(this.question).text())
    },
    search: debounce(function(question) {
      this.loading = true

      searchSupport(question, 'html')
        .then((response) => {
          if (response.data.count > 0) {
            this.results = response.data.html
          } else {
            this.results = false
          }
          this.showSendMessageNow = true
          this.loading = false
        })
        .catch((error) => {
          this.results = false
          this.error = true
          this.showSendMessageNow = true
          this.loading = false
        })
    }, 300),
    toggle () {
      if (this.visible) {
        this.hide()
      } else {
        this.show()
      }
    },
    isHelpKey (e) {
      if ((e.key || '') === '/') {
        if (this.isMacOS()) {
          return e.metaKey
        } else {
          return e.ctrlKey
        }
      }
    },
    isMacOS () {
      return navigator.userAgent.indexOf('Mac OS') !== -1
    },
    show () {
      this.visible = true
    },
    hide () {
      this.showMessage = false
      this.visible = false
      return true
    },
    hideAfterDelay: _.debounce(function () {
      this.hide()
    }, 150),
    onShown () {
      //
    },
    removeAttachment (id) {
      this.files = filter(this.files, (file) => {
        return file.id !== id
      })
    },
    onFileUploaded (file) {
      this.files.push(file)
    },
    bytes (number) {
      return numeral(number).format('0.00b')
    },
    async send () {
      this.sending = true
      try {
        let response = await sendSupportTicket({
          to: this.to,
          from: this.from,
          subject: this.question,
          body: this.message,
          attachments: this.files
        }, document.location.toString())

        this.to = {}
        this.message = null
        this.files = []
        this.hide()

        alertify.alert("Thank you. Your request has been received.")
      } catch (error) {
        if (error.response.status === 422) {
          let bag = MessageBag.fromResponse(error)
          alertify.alert(bag.first())
        } else {
          alertify.error("Oops! There was a problem sending your message. Please try again.")
        }
      } finally {
        this.sending = false
      }
    }
  }
}
</script>